import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../hooks/redux';
import { Tabs, TabItem } from '../../ui/Tabs/Tabs';
import { AISystemEntity } from '../../../types/AISystems.types';
import { DeployerControlMonitoring } from './components/DeployerControlMonitoring/DeployerControlMonitoring';
import { MonitoringIntervalSelector } from './components/MonitoringIntervalSelector/MonitoringIntervalSelector';
import { TechnicalMonitoring } from './components/TechnicalMonitoring/TechnicalMonitoring';

export function MonitoringAuditLogging() {
  const { id } = useParams<{ id: string }>();
  const currentOverviewEntityType = useAppSelector(
    (state) => state.aiSystems.currentOverview?.generalInfo.entityType
  );
  const currentOverviewAiSystemId = useAppSelector(
    (state) => state.aiSystems.currentOverviewAiSystemId
  );

  // currentOverview is a single global slot, not keyed per route — guard
  // against reading a still-cached PREVIOUS AI system's overview right after
  // navigating here, before this system's own overview has loaded.
  const rawEntityType =
    currentOverviewAiSystemId === id ? currentOverviewEntityType : undefined;
  const isDeployer =
    (rawEntityType as AISystemEntity | undefined) === AISystemEntity.DEPLOYER;

  const subTabs: TabItem[] = [
    { key: 'technical', label: 'Technical', content: <TechnicalMonitoring /> },
    {
      key: 'article-26-compliance',
      label: 'Article 26 Compliance',
      content: <DeployerControlMonitoring />
    }
  ];

  return (
    <div className="flex flex-col gap-4">
      {id && <MonitoringIntervalSelector aiSystemId={id} />}
      {isDeployer ? (
        <Tabs
          tabs={subTabs}
          basePath={`/ai-systems/${id}/monitoring-audit-logging`}
          hideAttentionMessage
        />
      ) : (
        <TechnicalMonitoring />
      )}
    </div>
  );
}
